export function normalizeRemoteAssetExpiresAt(value) {
  if (value == null || value === "") return null;

  const numeric = Number(value);
  if (Number.isFinite(numeric) && numeric > 0) {
    return numeric < 1e12 ? numeric * 1000 : numeric;
  }

  const parsed = Date.parse(String(value));
  if (Number.isFinite(parsed) && parsed > 0) {
    return parsed;
  }

  return null;
}

export function hasFreshRemoteAssetUrl(url, expiresAt, options = {}) {
  const normalizedUrl = String(url || "").trim();
  if (!normalizedUrl) return false;

  const minRemainingMs = Math.max(0, Number(options?.minRemainingMs) || 0);
  const allowMissingExpiry = options?.allowMissingExpiry !== false;
  const normalizedExpiresAt = normalizeRemoteAssetExpiresAt(expiresAt);

  if (!normalizedExpiresAt) {
    return allowMissingExpiry;
  }

  return normalizedExpiresAt > Date.now() + minRemainingMs;
}
